import ResponsiveNavbar from "./navbar";
import Footer from "./footer";
import { useEffect, useState } from "react";
import AdminNavbar from "./admin/adminNavbar";
import AdminSidebar from "./admin/adminSidebar";
import { useNavigate, useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const [showNavOptions, setShowNavOptions] = useState(true);
  const [showSidebarOptions, setShowSidebarOptions] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (currentPath.includes("admin")) {
      setShowNavOptions(false);
      if (!currentPath.includes("signin")) {
        setShowSidebarOptions(true);
        if (!localStorage.getItem("admintoken")) {
          navigate("/admin/signin");
          return;
        }
      } else {
        setShowSidebarOptions(false);
      }
      return;
    }
    setShowNavOptions(true);
  }, [currentPath, navigate]);

  return (
    <div style={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {showNavOptions ? <ResponsiveNavbar /> : <AdminNavbar />}
      {showSidebarOptions && <AdminSidebar />}
      <main
        style={{
          width: '100%',
          minHeight: !showNavOptions ? "100vh" : "calc(100vh - 130px)",
          background: !showNavOptions ? "#f8f8f8" : "#ffffff",
          marginLeft: showSidebarOptions ? 160 : 0,
        }}
      >
        {children}
      </main>
      {showNavOptions && <Footer />}
    </div>
  );
};

export default Layout;
